import React, { useState, useEffect, useRef } from "react";
import "./warrantGuestSpeakerVideo.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { Link, useParams, useLocation } from "react-router-dom";
import { get } from "lodash";
import API from "../../../utils/apiCalling";
import { config ,Base_Url,Api_MqMy} from "../../../utils/apiUrl";
import Slider from 'react-slick';


const WarrantGuestSpeakerVideo = (props) => {
  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow:1,
    slidesToScroll: 1,
    dots: false,
    arrow: false,
    dots: true,
  };
  const api = new API();
  const location = useLocation()
  const myRef = useRef(null);
  const myRef1 = useRef(null);
  const pathName = get(Location, "pathname", "");
  const [guestPage, setGuestPage] = useState(false)
  const [videoData, setVideoData] = useState([])
  const [banner, setBanner] = useState([])
  const getWarrantVideos = async () => {
      let WarrantSearchResult = await api.get(config.VideoWarrants, true);
      setVideoData(WarrantSearchResult)
  };
  const getWarrantVideosBanner = async () => {
      let WarrantSearchResult = await api.get(config.VideoWarrantsBanner, true);
      setBanner(WarrantSearchResult)
  };
  useEffect(() => {
    getWarrantVideos()
    getWarrantVideosBanner()
    var path = location.hash
    if (path == "#GuestSpeakerVideo") {
      setGuestPage(true)
    } else {
      setGuestPage(false)
    }
  }, [location])
  
  const { id } = useParams();
  const executeScroll = () => myRef.current.scrollIntoView();
  const executeScroll1 = () => myRef1.current.scrollIntoView();
  useEffect(() => {
    if (guestPage) {
      executeScroll();
    }
  }, [guestPage]);

  useEffect(() => {
    if (!guestPage) {
      executeScroll1();
    }
  }, [guestPage]);
  const getImg = (e)=>{
    var src= null
    if (e.image) {
      src = "https://t12a.trkd-hs.com/cmsapimqmy/v1/file/image/video/" + e.id;
    } else {
      src = 'https://i.ytimg.com/vi/' + e.playlist_id + '/mqdefault.jpg'
    }
    return src
  }
  return (
    <div id="dwvideo" className="pageobj" ref={myRef1}>
      <div className="breadcrumbbar">
        <div className="container-fluid">
          <ol className="breadcrumb">
            <li>
              <Link to="/home?edu">Warrant education</Link>
            </li>
            <li className="active">Warrant videos</li>
          </ol>
        </div>
      </div>
      <div className="stripe-bg" />
      <div className="container-fluid">
        <div className="section">
          <div className="page-header">
            <h1>Educational warrant videos</h1>
          </div>
          <p className="section-p">
            Learn about structured warrants with these bite-sized animated
            videos! In these videos, we will provide an introduction on
            structured warrants and the things to know when trading or investing
            in warrants.
          </p>
          <div id="videogallery">
                <Slider {...settings} className="show-desk">
                  {
                    banner.map((e)=>{
                      return (
                        <div className="gallery-item">
                            <Link
                                target="_blank"
                                to={e.link}
                              >
                              <img
                                style={{ width: "100%" }}
                                src={config.getBannerBase64+e.id}
                              />
                            </Link>
                        </div>
                      )
                    })
                  }
                </Slider>
                
              {/* </div> */}
            {/* </div> */}
          </div>
          {
            videoData.map((v,i)=>{
              return (
                <div className="content">
                  <div id="edurack" className="videorack">
                    <div className="videorack-title">{v.title}</div>
                    <div className="videorack-body">
                      <div className="videorack-content swiper-container swiper-container-horizontal">
                        <div className="swiper-wrapper">
                          <div
                            style={{ maxWidth: "1030px", width: "100%" }}
                          >
                            <Carousel
                              showArrows={true}
                              emulateTouch
                              showStatus={false}
                              autoFocus
                              infiniteLoop={false}
                              showIndicators={false}
                            >
                              {
                                new Array(Math.ceil(v.videos.length/3)).fill(0).map((a,b)=>{
                                  return (
                                     <div>
                                        <table
                                          className="videorack-page"
                                          style={{ width: "100%" }}
                                        >
                                          <tbody>
                                            <tr>
                                              {v.videos.map((v2,i2)=>{
                                                if(i2>=b*3 &&i2<=b*3+2){
                                                  return (
                                                    <td>
                                                      <Link
                                                        to={`/education/warrantvideosind/${v.title}/${v2.playlist_id}/${v2.index}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <div
                                                          playlistid={`${v2.playlist_id}`}
                                                          index={`${v2.index}`}
                                                          className="videorack-item"
                                                          style={{ display: "inline-block" }}
                                                        >
                                                          <img
                                                            style={{ width: "100%" ,maxWidth: '327px'}}
                                                            src={getImg(v2)}
                                                          />
                                                          <div className="videorack-item-txt">
                                                            <span className="text-bold" dangerouslySetInnerHTML={{__html:v2.title}}>
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </Link>
                                                    </td>
                                                  )
                                                }
                                              })}
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div> 
                                  );
                                })
                              }
                            </Carousel>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          }
          {/* <hr className="hr-hmgbm" /> */}
        </div>
      </div>
      <div id="demo" ref={myRef} />
    </div>
  );
};
export default WarrantGuestSpeakerVideo;
